import { NetworkBasePopUp } from '../NetworkBasePopUp';
import { SubmitToSandboxPanelWebComponent } from '../../../../network/submitToSandbox/submitToSandboxPanel';
import { translateFn } from '../../../../utils/translator.helper';
import { GzDialogWebComponent } from '../../../../ui/gzDialog';
import { GzDialog } from '../../../../ui/gzDialog/component/GzDialog';
import { SubmitToSandboxPanelEvents } from '../../../../network/submitToSandbox/submitToSandboxPanel/types';

export class SubmitToSandboxPopUp extends NetworkBasePopUp<undefined> {
  protected transformToTaskTarget = true;
  protected title = translateFn('Submit to Sandbox Analyzer');
  protected extraDialogConfigs = {
    isWindow: true,
  };

  private windowDialog: GzDialogWebComponent;

  protected async handleConfirmButtonClicked(event: CustomEvent) {} // not used

  protected customSetup() {
    if (!this.data.targets || !this.data.targets.length) {
      console.error('No targets selected for Sandbox Analyzer.');
      return;
    }

    const targetName = this.data.targets[0].name;
    const targetOs = this.data.targets[0].specifics.operatingSystem;

    const submitToSandboxPanel = new SubmitToSandboxPanelWebComponent();
    submitToSandboxPanel.apiClientInjectedFromNirvana = true;

    const dependencies = {
      api: {
        type: 'gz',
        clients: {
          Tasks: {
            createSubmitToSandboxTask: this.createSubmitToSandboxTask.bind(this),
          },
        },
      },
      getTargetName: () => targetName,
      getTargetOperatingSystem: () => targetOs,
      translateFn: translateFn,
      getUserLanguage: Application.Main.getLanguage,
      getTimezone: () => {
        const user = Application.Main.getUser();
        if (!user || !user.profile || !user.profile.timezone) {
          return 'UTC';
        }
        return user.profile.timezone;
      },
      getUser: Application.Main.getUser,
      isCloud: Application.Main.product.isCloud,
    };

    const dialogConfigs: GzDialog = {
      headline: translateFn('Submit to Sandbox Analyzer'),
      bodyContent: submitToSandboxPanel,
      isOpen: true,
      isWindow: true,
      closableOutsideBox: false,
    };

    this.windowDialog = GzDialogWebComponent.buildDialogElement(
      dialogConfigs,
      document.getElementById('mainPanel') as HTMLElement
    );

    submitToSandboxPanel.addEventListener(SubmitToSandboxPanelEvents.OnPanelClose, () => this.windowDialog.dismiss());
    submitToSandboxPanel.injectDependencies(dependencies);
    submitToSandboxPanel.start().then().catch(console.error);
  }

  private createSubmitToSandboxTask(settings: any) {
    settings = {
      ...settings,
      targets: this.data.targets || [],
      targetOperatingSystem: this.data.targets![0].specifics.operatingSystem,
      type: Constants.Tasks.Endpoints.TASK_TYPE_SUBMIT_TO_SANDBOX_PARENT,
    };

    return this.createTask({ settings });
  }
}
